var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 501.333 501.333",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#f4efe7"
    },
    points: "326.4,324.267 355.2,386.133 338.133,410.667 338.133,446.933 226.133,446.933 226.133,405.333 132.267,328.533 225.067,328.533 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0DF"
    },
    d: "M40.533,330.667L40.533,330.667C23.467,330.667,9.6,316.8,9.6,299.733c0-96,0-192,0-286.933 c19.2,11.733,42.667,11.733,61.867,0c0,96,0,192,0,286.933C71.467,316.8,57.6,330.667,40.533,330.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A5569"
    },
    d: "M467.2,340.267H40.533l30.933-40.533V0h429.867v306.133C501.333,325.333,486.4,340.267,467.2,340.267 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#637888"
    },
    d: "M40.533,340.267C18.133,340.267,0,322.133,0,299.733V0h19.2v299.733 c0,11.733,9.6,21.333,21.333,21.333s21.333-9.6,21.333-21.333V0h19.2v299.733C81.067,322.133,62.933,340.267,40.533,340.267z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4efe7"
    },
    d: "M270.933,135.467c-9.6-2.133-19.2,3.2-21.333,11.733l-38.4,135.467l34.133,9.6l38.4-134.4 C285.867,148.267,280.533,138.667,270.933,135.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4efe7"
    },
    d: "M320,123.733c-9.6-2.133-19.2,3.2-21.333,11.733l-44.8,158.933L288,304l44.8-158.933 C334.933,135.467,329.6,125.867,320,123.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4efe7"
    },
    d: "M355.2,160c-9.6-2.133-19.2,3.2-21.333,11.733l-38.4,134.4l34.133,9.6l38.4-134.4 C370.133,171.733,364.8,162.133,355.2,160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4efe7"
    },
    d: "M391.467,196.267c-9.6-2.133-19.2,3.2-21.333,11.733L339.2,318.933l34.133,9.6L404.267,217.6 C405.333,208,400,198.4,391.467,196.267z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.803,
    y: 262.343,
    transform: "matrix(-0.9622 -0.2725 0.2725 -0.9622 481.4936 695.0235)",
    style: {
      fill: "#f4efe7"
    },
    width: 166.407,
    height: 103.471
  })), /*#__PURE__*/React.createElement("rect", {
    x: 216.533,
    y: 440.533,
    style: {
      fill: "#e6a241"
    },
    width: 144,
    height: 60.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 419.2,
    style: {
      fill: "#E0E0DF"
    },
    width: 128,
    height: 20.267
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.d9dc638ac183e3855263f203cef4ad2a.svg";
export { ForwardRef as ReactComponent };